import React from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import LoadingSpinner from "../loading-spinner.jsx";
import styles from "./custom-button.module.scss";

function Button({
  children,
  onClick,
  variant = "primary",
  disabled = false,
  isLoading = false,
  faIcon = "",
  iconPosition = "left",
  size = "medium",
  fullWidth = false,
  testid = "",
  type = "button",
  color,
  ...rest
}) {
  return (
    <button
      className={classNames(styles.button, styles[variant], styles[size], {
        [styles.disabled]: disabled,
        [styles.loading]: isLoading,
        [styles.fullWidth]: fullWidth,
        [styles.danger]: color === "danger",
      })}
      onClick={onClick}
      disabled={disabled}
      data-testid={testid}
      type={type}
      {...rest}
    >
      {isLoading ? (
        <LoadingSpinner size={"16px"} />
      ) : (
        <>
          {faIcon && iconPosition === "left" && <FontAwesomeIcon icon={faIcon} />}
          {children}
          {faIcon && iconPosition === "right" && <FontAwesomeIcon icon={faIcon} />}
        </>
      )}
    </button>
  );
}

Button.propTypes = {
  children: PropTypes.node.isRequired,
  onClick: PropTypes.func,
  variant: PropTypes.oneOf(["primary", "secondary", "tertiary"]),
  disabled: PropTypes.bool,
  isLoading: PropTypes.bool,
  faIcon: PropTypes.object,
  iconPosition: PropTypes.oneOf(["left", "right"]),
  size: PropTypes.oneOf(["small", "medium", "large"]),
  fullWidth: PropTypes.bool,
  type: PropTypes.oneOf(["button", "submit", "reset"]),
  color: PropTypes.oneOf(["danger"]),
};

export default Button;